import { cardsData } from "@/mocks/homeData";

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              🔥 今日热门爆料
            </h2>
            <p className="text-sm text-foreground-600 mt-1">
              全网最热51吃瓜资讯，实时更新中
            </p>
          </div>
          <a
            href="#topics"
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector("#topics");
              if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" });
            }}
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardsData.map((card, i) => (
            <article
              key={i}
              className={`group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-primary-200/50 ${
                i === 0 ? "lg:col-span-2 lg:row-span-2" : ""
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? "aspect-[16/9]" : "aspect-[4/3]"}`}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-md whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className={`font-semibold text-foreground-950 leading-snug mb-2 line-clamp-2 font-heading ${
                  i === 0 ? "text-base md:text-lg" : "text-sm md:text-base"
                }`}>
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {card.summary}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {card.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}